export default {"src":"/_next/static/media/arrow-right.39d7b44c.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};